import { __decorate, __extends } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import AddOrEdit from './components/index.vue';

var AddVasOrderPage = function (_super) {
  __extends(AddVasOrderPage, _super);

  function AddVasOrderPage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  AddVasOrderPage = __decorate([Component({
    components: {
      AddOrEdit: AddOrEdit
    }
  })], AddVasOrderPage);
  return AddVasOrderPage;
}(Vue);

export default AddVasOrderPage;